import React from 'react';
import { NavLink } from 'react-router-dom';

const EventsCrumb = () => <NavLink to="/admin/events">Events</NavLink>;

export default EventsCrumb;
